@let hpfc = data();
<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 min-h-74"
>
  <div class="flex gap-2 items-center">
    <div class="flex-1 flex-col">
      <h2 class="leading-6 font-semibold">
        {{ 'cockpit.dashboard.hpfcPriceCard.title' | transloco }}
      </h2>
      <span class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
        @switch (filter().granularity) {
          @case ('YEAR') {
            {{
              'cockpit.dashboard.hpfcPriceCard.yearSubtitle'
                | transloco: { year: (filter().date | date: 'yyyy') }
            }}
          }
          @case ('WEEK') {
            {{
              'cockpit.dashboard.hpfcPriceCard.weekSubtitle'
                | transloco: { week: (filter().date | date: 'ww') }
            }}
          }
        }
      </span>
    </div>
    <ui-switch-bar [formField]="form.granularity" class="flex-none">
      <ui-switch-bar-option value="YEAR">
        {{ 'cockpit.dashboard.hpfcPriceCard.view.year' | transloco }}
      </ui-switch-bar-option>
      <ui-switch-bar-option value="WEEK">
        {{ 'cockpit.dashboard.hpfcPriceCard.view.week' | transloco }}
      </ui-switch-bar-option>
    </ui-switch-bar>
  </div>
  <app-analysis-price-graph-chart
    class="flex-none h-[240px] w-full block"
    [prices]="hpfc?.data?.entries ?? []"
    [granularity]="filter().granularity"
    [showEurMwh]="filter().showEurMwh"
    [loading]="hpfc?.isLoading ?? true"
    [error]="hpfc?.error"
    (clickReload)="onClickReload()"
  />
</div>
